import styled from "styled-components";
import { Body1Styles, Body6, Breakpoint } from "@arcteryx/components-typography";

export const ErrorText = styled(Body6).attrs({ tag: "span" })`
  color: var(--warning-red);
  padding: 4px 2px 4px 2px;
`;
export const Message = styled.ul`
  font-size: 1rem;
  margin: 0 auto;
  ${Breakpoint("lg")`
  column-count: 2;
  `}
  ${Breakpoint("xs")`
  column-count: 1;
  padding: var(--space-blue) var(--space-blue) !important;
  `}
  column-gap: var(--space-blue);
  list-style: none !important;
  li {
    white-space: nowrap;
    &.input-validation-error-message {
      color: var(--warning-red);
      font-style: italic;
      &:before {
        color: var(--warning-red);
      }
    }
    &.input-validation-valid {
      color: var(--colour-copy);
      font-style: normal;
      &:before {
        content: url(//images-dynamic-arcteryx.imgix.net/foundation-ui/svgs/Success_Icon.svg);
        width: 1rem;
        height: 1rem;
        display: inline-block;
      }
    }
    &:before {
      content: "•";
      color: var(--colour-copy);
      padding: 0 0.5rem 0 0;
    }
  }
`;
export const FormInput = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  transition: all 0.4s ease-in-out;
  &:after {
    content: none;
    display: inline-block;
    width: 17px;
    height: 17px;
    bottom: 15px;
    right: 15px;
    position: absolute;
  }
  &.input-validation-error:after {
    content: ${(props) =>
      !props.isSelect && "url(//images-dynamic-arcteryx.imgix.net/foundation-ui/svgs/Warning_Icon.svg)"};
  }
  &.input-validation-valid:after {
    content: ${(props) =>
      !props.isSelect && "url(//images-dynamic-arcteryx.imgix.net/foundation-ui/svgs/Success_Icon.svg)"};
  }
`;

export const RequiredSpan = styled(Body6).attrs({ tag: "span" })`
  color: var(--warning-red);
  margin: 0;
`;

const handleMarginType = (props) => {
  if (props.isRelatedToPrevious && props.isCheckbox) {
    return "-7.5px 0 30px 0";
  } else if (!props.isRelatedToPrevious && props.isCheckbox) {
    return "30px 0";
  } else if ((props.isMenu && props.isSelect) || props.isPasswordStrength || props.isPromoCode) {
    return "0";
  }
  return "0 0 22.5px 0";
};

export const FormRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: ${(props) => handleMarginType(props)};
  width: 100%;
  padding: 0;
`;

export const InputField = styled.input`
  -webkit-appearance: none;
  border-radius: 0;
  border: 1px solid var(--dark-grey);
  width: 100%;
  height: 3rem;
  background: var(--white);
  padding: 0 45px 0 15px;
  color: var(--black);
  ${Body1Styles};
  max-width: unset;
  text-align: inherit;
  box-shadow: none;
  .input-validation-valid & {
    border: 1px solid var(--success-green);
  }
  .input-validation-error & {
    border: 1px solid var(--warning-red);
  }
  &:focus {
    outline: none;
    border: 1px solid var(--focus-blue);
  }
  &:read-only,
  &:disabled {
    border: 1px solid var(--medium-grey);
    color: var(--medium-grey);
    cursor: not-allowed;
    opacity: 0.4;
  }
`;
export const TextAreaField = styled.textarea`
  border: 1px solid var(--dark-grey);
  width: 100%;
  max-width: 100%;
  height: auto;
  background: var(--white);
  padding: 1rem;
  color: var(--black);
  ${Body1Styles};
  max-width: unset;
  text-align: inherit;
  box-shadow: none;
  .input-validation-valid & {
    border: 1px solid var(--success-green);
  }
  .input-validation-error & {
    border: 1px solid var(--warning-red);
  }
  &:focus {
    outline: none;
    border: 1px solid var(--focus-blue);
  }
  &:disabled {
    border: 1px solid var(--inactive-state-grey);
    cursor: not-allowed;
  }
`;

export const StyledSelect = styled.select`
  color: ${(props) => (props.$isGray ? "gray" : "var(--colour-black)")};
  ${Body1Styles};
  text-align: inherit;
  padding: 0 45px 0 15px;
  position: relative;
  display: flex;
  margin: 0;
  width: 100%;
  transition: all 0.4s ease-in-out;
  height: 45px;
  border: 1px solid #333;
  border-radius: 0;
  outline: none;
  box-shadow: none;
  background: url(//images.arcteryx.com/foundation-ui/svgs/Select_Arrow.svg) 96% / 3% no-repeat #fff;

  &:after {
    content: "X";
    position: absolute;
    right: 0;
  }
  &:-moz-focusring {
    color: transparent;
    border: 2px solid #e9e9e9;
    text-shadow: 0 0 0 var(--colour-black);
  }
  &:focus {
    border: 1px solid var(--focus-blue);
  }
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  .input-validation-valid & {
    border: 1px solid var(--success-green);
  }
  .input-validation-error & {
    border: 1px solid var(--warning-red);
  }

  #input-place-holder {
    display: none;
  }
`;
export const SectionField = styled.section`
  font-family: var(--font-helvetica);
  border: 1px solid var(--dark-grey);
  width: 100%;
  max-width: 100%;
  background: var(--white);
  padding: 1rem;
  color: var(--black);
  font-size: 1rem;
  box-shadow: none;
  height: auto;
  min-height: 12rem;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  .input-validation-valid & {
    border: 1px solid var(--success-green);
  }
  .input-validation-error & {
    border: 1px solid var(--warning-red);
  }
  &:focus {
    outline: none;
    border: 1px solid var(--focus-blue);
  }
  &:disabled {
    border: 1px solid var(--inactive-state-grey);
    cursor: not-allowed;
  }
`;
